import React from 'react'
import SubPageHeader from '../components/subPageHeader'
import Plans from '../components/plans'
import { Helmet } from 'react-helmet'

export default ({ title, description, background, url }) => (
  <SubPageHeader
    title={title}
    text={description}
    background={background}
    currentUrl={url}
    variant="Pricing"
  >
    <Plans />
  </SubPageHeader>
)
